export const SvgBeanEater = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 100 100"
            preserveAspectRatio="xMidYMid"
            style={{ shapeRendering: "auto", display: "block" }}
        >
            <g>
                <g>
                    <circle fill="#205bee" r="4" cy="50" cx="60">
                        <animate begin="-0.67s" keyTimes="0;1" values="95;35" dur="1s" repeatCount="indefinite" attributeName="cx" />
                        <animate begin="-0.67s" keyTimes="0;0.2;1" values="0;1;1" dur="1s" repeatCount="indefinite" attributeName="fill-opacity" />
                    </circle>
                    <circle fill="#205bee" r="4" cy="50" cx="60">
                        <animate begin="-0.33s" keyTimes="0;1" values="95;35" dur="1s" repeatCount="indefinite" attributeName="cx" />
                        <animate begin="-0.33s" keyTimes="0;0.2;1" values="0;1;1" dur="1s" repeatCount="indefinite" attributeName="fill-opacity" />
                    </circle>
                    <circle fill="#205bee" r="4" cy="50" cx="60">
                        <animate begin="0s" keyTimes="0;1" values="95;35" dur="1s" repeatCount="indefinite" attributeName="cx" />
                        <animate begin="0s" keyTimes="0;0.2;1" values="0;1;1" dur="1s" repeatCount="indefinite" attributeName="fill-opacity" />
                    </circle>
                </g>
                <g transform="translate(-15 0)">
                    <path transform="rotate(90 50 50)" fill="#ffe633" d="M50 50L20 50A30 30 0 0 0 80 50Z" />
                    <path fill="#ffe633" d="M50 50L20 50A30 30 0 0 0 80 50Z">
                        <animateTransform keyTimes="0;0.5;1" values="0 50 50;45 50 50;0 50 50" dur="1s" repeatCount="indefinite" type="rotate" attributeName="transform" />
                    </path>
                    <path fill="#ffe633" d="M50 50L20 50A30 30 0 0 1 80 50Z">
                        <animateTransform keyTimes="0;0.5;1" values="0 50 50;-45 50 50;0 50 50" dur="1s" repeatCount="indefinite" type="rotate" attributeName="transform" />
                    </path>
                </g>
            </g>
        </svg>
    )
}